import { Col, Row, Modal, Form, Switch, message } from "antd";
import { Dispatch, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { PriceType } from "./priceType";
import "react-datepicker/dist/react-datepicker.css";
import { editPriceScheme, createPriceScheme } from "../../../api/pricescheme";
import Title from "../../UI/Title/Title";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";
import TextArea from "../../UI/InputNumberComponent/TextArea";

type propsType = {
  price?: PriceType | undefined;
  openPrice: boolean;
  id?: any;
  setOpenPrice: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  filter: boolean | undefined;
  search: string;
  setPaginatedtPriceScheme: Dispatch<any>;
  PriceSchemeMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
};

export const AddEditPrice = ({
  price,
  openPrice,
  id,
  setOpenPrice,
  page,
  search,
  filter,
  setPaginatedtPriceScheme,
  PriceSchemeMutation,
}: propsType) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const [isActive, setIsActive] = useState<boolean>(
    price ? price?.isActive : true
  );
  const isEdit = () => {
    return !!id && id !== undefined && id !== "";
  };

  const onError = (error: any, variables: PriceType, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createPriceScheme" : "editPriceScheme",
    !isEdit()
      ? (price: PriceType) => createPriceScheme(price)
      : (price: PriceType) => editPriceScheme(id as string, price),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenPrice(false);
        message.success("Complete successfully");
        PriceSchemeMutation({
          q: search,
          isActive: filter,
          limit: page * 8 + 8,
        }).then((res: any) => {
          setPaginatedtPriceScheme(res.data?.data);
        });
      },
      onError,
    }
  );

  const handleFinish = () => {
    const newPrice = form.getFieldsValue();
    for (const key in newPrice) {
      if (newPrice[key] === undefined) {
        if (key === "isActive") {
          newPrice[key] = true;
        } else {
          newPrice[key] = null;
        }
      } else if (
        typeof newPrice[key] === "string" &&
        newPrice[key].trim() === ""
      ) {
        newPrice[key] = null;
      }
    }
    delete newPrice["date"];
    mutateCreateUpdate(newPrice);
  };

  const [PriceSchemeValid, setIsPriceSchemeValid] = useState(false);
  const handleInputAbbreviation = (value: any) => {
    setIsPriceSchemeValid(value);
  };
  const [editStatus] = useState(isEdit());

  useEffect(() => {
    if (editStatus) {
      setIsPriceSchemeValid(true);
    }
  }, [editStatus]);

  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        centered
        width={490}
        onCancel={() => setOpenPrice(false)}
        open={openPrice}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !PriceSchemeValid,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Title
          title={
            isEdit() ? `${t("edit-price-scheme")}` : `${t("add-price-scheme")}`
          }
        />
        {isEdit() && (
          <span className="modaltitleEdit">
            {t("edit-details-for")} {price?.name}
          </span>
        )}
        <Form
          data-testid="form"
          layout="vertical"
          form={form}
          id="PriceSchemeForm"
          onFinish={handleFinish}
        >
          <Row>
            <Col span={14} style={{ marginTop: "20px" }}>
              <Form.Item
                name="name"
                label={t("price-scheme-name")}
                initialValue={price?.name}
                rules={[
                  {
                    required: true,
                    message: "price scheme name is required",
                  },
                ]}
              >
                <InputName
                  maxLength={50}
                  data-testid="name"
                  onChange={handleInputAbbreviation}
                />
              </Form.Item>

              <Form.Item
                name="description"
                label={`${t("description")}`}
                initialValue={price?.description}
              >
                <TextArea maxLength={500} data-testid="description-input" />
              </Form.Item>

              <Form.Item
                style={{ margin: "2px" }}
                name="isActive"
                label={`${t("status")}`}
              >
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="PriceSchemeForm"
        open={open}
        setOpen={setOpen}
        name={<span>{price?.name}</span>}
        title={`${t("pricescheme")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
